export default __webpack_public_path__ + "static/media/logout.feb9fbcc.svg";